import { render, staticRenderFns } from "./ConversionRatesModal.vue?vue&type=template&id=0b3bb130&scoped=true&"
import script from "./ConversionRatesModal.vue?vue&type=script&lang=js&"
export * from "./ConversionRatesModal.vue?vue&type=script&lang=js&"
import style0 from "./ConversionRatesModal.vue?vue&type=style&index=0&id=0b3bb130&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3bb130",
  null
  
)

export default component.exports